import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Students from "@/pages/Students";
import StudentDetail from "@/pages/StudentDetail";
import Meetings from "@/pages/Meetings";
import Schedule from "@/pages/Schedule";
import ParentDashboard from "@/pages/ParentDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Layout from "@/components/Layout";
import "@/App.css";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center text-[#6B726F]">
      <span className="calm-pulse">Loading…</span>
    </div>
  );
}

function homeForRole(role) {
  if (role === "admin") return "/admin";
  if (role === "parent") return "/parent";
  return "/";
}

function TeacherOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "teacher") return <Navigate to={homeForRole(user.role)} replace />;
  return <Layout>{children}</Layout>;
}

function ParentOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "parent") return <Navigate to={homeForRole(user.role)} replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to={homeForRole(user.role)} replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/parent" element={<ParentOnly><ParentDashboard /></ParentOnly>} />
          <Route path="/admin" element={<AdminOnly><AdminDashboard /></AdminOnly>} />
          <Route path="/" element={<TeacherOnly><Dashboard /></TeacherOnly>} />
          <Route path="/students" element={<TeacherOnly><Students /></TeacherOnly>} />
          <Route path="/students/:id" element={<TeacherOnly><StudentDetail /></TeacherOnly>} />
          <Route path="/meetings" element={<TeacherOnly><Meetings /></TeacherOnly>} />
          <Route path="/schedule" element={<TeacherOnly><Schedule /></TeacherOnly>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
